import { EventName } from './EventName';

export interface EventMappingDay {
  day: string; // YYYY-MM-DD
  isFrozen: boolean;
  isBad: boolean;
}

export interface EventMapping {
  businessID: number;
  incoming: EventName;
  new: EventName;
  repeating: EventName;
  version: number;
  days: EventMappingDay[];
}

export const exampleEventMapping: EventMapping = {
  businessID: 5,
  incoming: EventName.AddPaymentInfo,
  new: EventName.AddPaymentInfo,
  repeating: EventName.AddToCart,
  version: 1,
  days: [],
};
